import axios from 'axios';

const save = (idEncoded, resposta) => axios.post(`/external/resposta/${idEncoded}`, resposta);
const update = (idEncoded, resposta) => axios.put(`/external/resposta/${idEncoded}`, resposta);

export default {
  save,
  update,
};
